import { RootState } from '@app/redux/root-reducer';

export const selectAddHolidayState = (store: RootState) => store.holidaysReducer.addHoliday;
export const selectHolidaysState = (store: RootState) => store.holidaysReducer.holidays;
export const selectDeleteHolidayState = (store: RootState) => store.holidaysReducer.deleteHoliday;
export const selectUpdateHolidayState = (store: RootState) => store.holidaysReducer.updateHoliday;
